import './PromoteJobWidget.scss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';

import cxHelpers from 'util/className';

@cxHelpers('PromoteJobWidget')
export default class PromoteJobWidget extends PureComponent {
  static propTypes = {
    image: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    subheader: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
  };

  render() {
    const { children, header, subheader, image } = this.props;

    return (
      <Box vcenter evenwidth className={this.cxEl('row')}>
        <Box paxl className={this.cx()}>
          <div className={this.cxEl('column')}>
            <h4>{header}</h4>
            <p>{subheader}</p>
            <div className="mts">{children}</div>
          </div>

          <div className={this.cxEl('image-column')}>
            <img
              className={this.cxEl('image')}
              src={require(`./images/${image}`)}
              alt="Promotion"
            />
          </div>
        </Box>
      </Box>
    );
  }
}
